import React, { useEffect, useState } from "react";
import { Checkbox, Col, Form, Row, Button, message } from "antd";
import "./setting_update_item_spareparts.css";
import axios from "axios";

const SettingUpdateItemPart: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    useEffect(() => {
        const fetchSettings = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/update-item-part`);
                form.setFieldsValue({ list_check: response.data.list_check });
            } catch (error) {
                console.error("Gagal mengambil pengaturan:", error);
                message.error("Gagal mengambil data pengaturan dari server.");
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, [form]);

    const onFinish = async (values: { list_check: string[] }) => {
        setLoading(true);
        const key = 'savingSettings';
        message.loading({ content: 'Menyimpan pengaturan...', key });
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/settings/update-item-part`, {
                list_check: values.list_check || []
            });
            message.success({ content: response.data.message, key, duration: 2 });
        } catch (error: any) {
            console.error("Gagal menyimpan pengaturan:", error);
            const errorMessage = error.response?.data?.error || "Gagal menyimpan pengaturan ke server.";
            message.error({ content: errorMessage, key, duration: 3 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ixq5" style={transformStyle}>
            <Form form={form} onFinish={onFinish} layout="vertical">
                <div className="gjs-grid-row" id="iwz2">
                    <div className="gjs-grid-column" id="ih9j">
                        <Form.Item label="List Allow Part Update" name="list_check" style={{ marginBottom: "5px" }}>
                            <Checkbox.Group style={{ width: "100%" }}>
                                <Row>
                                    <Col span={8}>
                                        <Checkbox value="1">Item Name</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="2">Brand</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="3">Item Class</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="4">Qty</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="5">HPP</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="6">Sales Price</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="7">UOM</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="8">UOM Rate</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="9">Location Rack</Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                </div>
                <div className="gjs-grid-row" id="iabcs">
                    <div className="gjs-grid-column" id="idefg">
                        <Form.Item style={{ marginTop: '20px' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Save Settings
                            </Button>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default SettingUpdateItemPart;